import { LandscapeSegment } from '@apiHooks/useLandscapeRestaurantData';

export interface TotalSegmentRow {
    segmentName: string;
    chainUnits: number;
    chainUnitsGrowth: number | null;
    independentUnits: number | null;
}

const sumBy = (
    segments: LandscapeSegment[],
    pick: (s: LandscapeSegment) => number | null | undefined,
): number => segments.reduce((acc, s) => acc + (pick(s) ?? 0), 0);

export function computeTotalRow(segments: LandscapeSegment[]): TotalSegmentRow {
    const hasIndependentData = segments.some((s) => s.independentUnits != null);
    return {
        segmentName: 'Total',
        chainUnits: sumBy(segments, (s) => s.chainUnits),
        chainUnitsGrowth: sumBy(segments, (s) => s.chainUnitsGrowth),
        independentUnits: hasIndependentData ? sumBy(segments, (s) => s.independentUnits) : null,
    };
}
